<ng-container *ngIf="open">
  <button class="mobile-navigation-backdrop" type="button" aria-label="Close navigation" data-testid="mobile-navigation-backdrop" (click)="close()"></button>
  <aside class="mobile-navigation-drawer" aria-label="Primary navigation" data-testid="mobile-navigation-drawer">
    <div class="mobile-navigation-drawer__header">
      <span>TEVUNA</span>
      <button class="mobile-navigation-drawer__close" type="button" aria-label="Close navigation" (click)="close()">×</button>
    </div>
    <nav class="mobile-navigation-drawer__links">
      <button type="button" data-testid="mobile-navigation-workspace" (click)="navigate(['/'])">Workspace</button>
      <button type="button" (click)="navigate(['/reports'])">Intelligence cases</button>
      <button type="button" (click)="navigate(['/account'])">My account</button>
      <ng-container *ngIf="(isAdmin$ | async) || (isSales$ | async)">
        <p>Administration</p>
        <button *ngIf="isAdmin$ | async" type="button" (click)="navigate(['/admin'])">Reports Dashboard</button>
        <button type="button" (click)="navigate(['/accounts'])">Manage Accounts</button>
      </ng-container>
    </nav>
  </aside>
</ng-container>
